// extracted by mini-css-extract-plugin
export default {"hideProduct":"PurchaseResult_hideProduct__w89oZ","purchaseResult":"PurchaseResult_purchaseResult__GoIgN"};